import {initialValues as PointRequestHistoryInitialState} from '@/views/points/PointRequestHistory.vue';
import {RouteRecordRaw} from 'vue-router';

const routes: RouteRecordRaw[] = [
    {
        // 포인트 지급/회수 요청내역
        path: '/points/request-history',
        name: 'PointRequestHistory',
        meta: {
            title: '포인트 지급/회수 요청내역',
        },
        components: {
            default: () => import('@/views/points/PointRequestHistory.vue'),
            NavBar: () => import('@/components/common/layout/NavBar.vue'),
            SideBar: () => import('@/components/common/layout/SideBar.vue'),
        },
    },
    {
        // 포인트 지급/회수 대상
        path: '/points/target',
        name: 'PointTargetList',
        meta: {
            title: '포인트 지급/회수 대상',
        },
        components: {
            default: () => import('@/views/points/PointTargetList.vue'),
            NavBar: () => import('@/components/common/layout/NavBar.vue'),
            SideBar: () => import('@/components/common/layout/SideBar.vue'),
        },
        beforeEnter: (to, from, next) => {
            // NOTE: provideId 값은 필수. 존재하지 않을시 포인트 지급/요청내역 페이지로 이동

            if (Number(to.query.provideId)) {
                next();
            } else {
                window.customAlert(
                    '데이터 조회에 필요한 포인트 지급/회수 요청번호(provideId) 정보가 존재하지 않습니다.',
                    () =>
                        next({
                            name: 'PointRequestHistory',
                            query: {
                                ...PointRequestHistoryInitialState,
                                page: 1,
                            },
                        }),
                );
            }
        },
    },
    {
        // 정산 내역 (신규 · bizpoint-partner-api)
        //
        // 기존 「정산 내역」이 쓰던 경로를 신규 화면이 승계한다. 메뉴명·URL이 계속
        // 정본을 가리키게 하려는 것이며, 구 데이터 화면은 아래 legacy 경로로 옮긴다.
        path: '/points/biz-settlement/biz-point-rent',
        name: 'SettlementHistory',
        meta: {
            title: '정산 내역',
        },
        components: {
            default: () => import('@/views/points/SettlementHistory.vue'),
            NavBar: () => import('@/components/common/layout/NavBar.vue'),
            SideBar: () => import('@/components/common/layout/SideBar.vue'),
        },
    },
    {
        // 구.정산내역 (2024.05.01~2026.08.31) · 조회 전용
        //
        // 화면·API는 그대로 보존하고 경로만 옮겼다(FRONTDEV-13733).
        // route name은 컴포넌트명을 따라 그대로 둔다.
        path: '/points/biz-settlement/legacy',
        name: 'BizPointSettlements',
        meta: {
            title: '구.정산내역',
        },
        components: {
            default: () => import('@/views/points/BizSettlements.vue'),
            NavBar: () => import('@/components/common/layout/NavBar.vue'),
            SideBar: () => import('@/components/common/layout/SideBar.vue'),
        },
    },
    {
        // 포인트 사용 내역
        path: '/points/usage-history',
        name: 'PointUsageHistory',
        meta: {
            title: '포인트 사용 내역',
        },
        components: {
            default: () => import('@/views/points/PointUsageHistory.vue'),
            NavBar: () => import('@/components/common/layout/NavBar.vue'),
            SideBar: () => import('@/components/common/layout/SideBar.vue'),
        },
    },
];

export default routes;
